import Avatar from "@material-ui/core/Avatar";
import React from "react";
import { CommentsListAvatarProps } from "./comments-list-avatar.props";
import { HostContainer } from "./comments-list-avatar.styles";

export const CommentsListAvatar = (props: CommentsListAvatarProps) => (
  <HostContainer>
    <Avatar
      title={`${props.user.firstName} ${props.user.lastName}`}
      alt={`${props.user.firstName} ${props.user.lastName}`}
      src={(props.user.profileImageUrl) ? props.user.profileImageUrl : "/profile.png" }
    />
  </HostContainer>
);
